// extracted by mini-css-extract-plugin
module.exports = {"inputRow":"ForgotPasswordPage_inputRow__2-0XG","submit":"ForgotPasswordPage_submit__iJ8JQ","error":"ForgotPasswordPage_error__sIk6l"};